export const environment = {
  SONARLINT_USER_HOME: 'C:\Murali_Workarea\SGDevelopment\Web_Development\new_mdh\MDH.Web',
  production: false,
  uat: false,
  development: false,
  swenable: true,
  name:'production',
  Application_URL: 'https://mdh.saint-gobain.com',
  Temp_App_URL: 'http://localhost',

  eaction_path: 'eactionweb',
  echeck_path: 'echeckweb',
  eevent_path: 'eeventweb',
  erisk_path: 'eriskweb',
  esmat_path: 'esmatweb',
  etag_path: 'etagweb',
  mdh_path: 'mdhweb',
  qewo_path: 'qewoweb',
  rewo_path: 'rewoweb',
  quickkaizen_path: 'quickkaizenweb',
  ptw_path: 'ptwweb',
  herca_path: 'hercaweb',
  opexplus_tags_path:'opexplusweb',

  federation_Url: 'assets/dynamic federation/mf.manifest.prd.json?v='+(new Date().getTime()),
  Logout_URL: 'https://connect.saint-gobain.com/oauth2/default/v1/logout',
  MDHAuthAPI: {
    endpoint: "https://api-i.mdh.saint-gobain.com",
  },
  appInsights:{
    connectionString: 'InstrumentationKey=b1ad1e5f-26fc-410a-a9ef-29f052bc2dfa;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=21becb72-bc13-4e7b-90b1-abfda81c3d92',
  }
};
